import { CostBasisPosition } from '@store/reducers/cost-basis/cost-basis.reducer';
import {
  InternalTransferMethodEnum,
  InternalTransferTypeEnum,
} from '@store/reducers/internal-transfer/internal-transfer.reducer';

import { math } from './mathjs/mathjs';

export { getEstimatedTotalTransferValue, getEstimatedValueOfTransferByShares } from '@sharedUtils';
export function getSharesToTransfer(
  percentage: number,
  position: CostBasisPosition,
  transferType: InternalTransferTypeEnum,
  transferMethod: InternalTransferMethodEnum,
): CostBasisPosition {
  const newPosition: CostBasisPosition = { ...position };
  if (transferType === InternalTransferTypeEnum.ENTIRE_ACCOUNT) {
    newPosition.sharesToTransfer = newPosition.shareQuantity;
  } else if (transferMethod === InternalTransferMethodEnum.PERCENT) {
    newPosition.sharesToTransfer = Number(
      math.format(math.multiply(+newPosition.shareQuantity, math.divide(percentage, 100)), {
        notation: 'fixed',
        precision: 4,
      }),
    );
  }
  return newPosition;
}
export function getEstimatedValueOfTransferByPercent(
  percent: number,
  position: CostBasisPosition,
): CostBasisPosition {
  const newPosition: CostBasisPosition = { ...position };

  const value = newPosition.settlementFund
    ? +newPosition.balance * (percent / 100)
    : +newPosition.sharesToTransfer * +newPosition.price;

  newPosition.estValueOfTransfer = +math.format(value, { notation: 'fixed', precision: 2 });

  return newPosition;
}
